import { PortalAPI } from "../infrastructure/portalApi";

/** The invitation a professional sent, as the public link shows it. */
export async function getPortalInvitation(token: string) {
  const { data } = await PortalAPI.getInvitation(token);
  return data;
}

/** Link the signed-in portal account to the invited record. */
export async function acceptPortalInvitation(token: string) {
  const { data } = await PortalAPI.acceptInvitation(token);
  return data;
}
